const COOKIE_NAME = '_el_cid'
const COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

interface CookieOptions {
  domain?: string
}

const readCookie = (): string | null => {
  if (typeof document === 'undefined') return null
  const cookies = document.cookie.split(';')
  for (const raw of cookies) {
    const [key, ...rest] = raw.trim().split('=')
    if (key === COOKIE_NAME) return decodeURIComponent(rest.join('='))
  }
  return null
}

const writeCookie = (value: string, options: CookieOptions = {}): void => {
  if (typeof document === 'undefined') return
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(value)}`,
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    'Path=/',
    'SameSite=Lax',
  ]
  if (typeof location !== 'undefined' && location.protocol === 'https:') {
    parts.push('Secure')
  }
  if (options.domain != null && options.domain !== '') {
    parts.push(`Domain=${options.domain}`)
  }
  document.cookie = parts.join('; ')
}

export { readCookie, writeCookie, COOKIE_NAME }
